// import values from 'lodash/values';
import { ROLES, isProd } from './core/constants';

const {
  User,
  Service,
  CountryManager,
  SuperAdmin,
  Partner,
  Marketing,
  Sales,
  Reporting,
} = ROLES;

// const ALL_VISITORS = values(ROLES);
const ALL_OM_USERS = [
  User,
  Service,
  CountryManager,
  SuperAdmin,
  Partner,
  Marketing,
  Sales,
];

export const ConnectedACLRules = {
  DashboardPage: ALL_OM_USERS,
  ConfigurationPage: [Service, SuperAdmin],
  MyProfilePage: [Service, SuperAdmin],
  CountriesPage: [Service, SuperAdmin],
  CountrySettingsPage: [Service, SuperAdmin, CountryManager],
  CountriesPageCreate: [Service],
  PosPage: [Service, CountryManager, SuperAdmin],
  PosPageCreate: [Service],
  PosPageEditFields: [Service],
  UsersPage: [Service, SuperAdmin],
  OffersPage: ALL_OM_USERS,
  OffersArchivesPage: ALL_OM_USERS,
  OffersArchivePage: ALL_OM_USERS,
  OffersSearchAllPosPage: ALL_OM_USERS,
  OffersSearchCrossPosPage: ALL_OM_USERS,
  OffersPageAddingOffers: [
    User,
    Service,
    CountryManager,
    SuperAdmin,
    Marketing,
  ],
  OffersPageAddingOffersFromFile: isProd
    ? []
    : [User, Service, CountryManager, SuperAdmin, Partner, Marketing],
  OffersPageRefreshMTData: [
    User,
    Service,
    CountryManager,
    SuperAdmin,
    Partner,
    Marketing,
  ],
  PublishOffersBulkPage: [
    User,
    Service,
    CountryManager,
    SuperAdmin,
    Partner,
    Marketing,
  ],
  OffersBulkActionsPage: [User, Service, CountryManager, SuperAdmin],
  ManagePortalPage: [SuperAdmin, Marketing],
  SEOPage: [Service, CountryManager, SuperAdmin, Marketing],
  UploadPhotos: [User, Service, CountryManager, SuperAdmin, Marketing],
  TransactionsPage: [Service, SuperAdmin],
  TranslationsPage: [Service, SuperAdmin],
  LabelsPage: [Service, SuperAdmin, Marketing, CountryManager],
  FuelsPage: [Service, SuperAdmin, CountryManager],
  PartnerCompaniesPage: isProd ? [] : [Service, SuperAdmin],
  VehicleGroupsPage: isProd ? [] : [Service, SuperAdmin],
  PromotionParametersPage: isProd ? [] : [Service, SuperAdmin],
  ReportsBudgetPage: [Service, SuperAdmin],
  ReportsMonthlyOffersPage: [Service, SuperAdmin, Reporting],
  ReportsDraftsPage: [
    User,
    Service,
    CountryManager,
    SuperAdmin,
    Marketing,
    Reporting,
  ],
  ReportsPage: [
    User,
    Service,
    CountryManager,
    SuperAdmin,
    Partner,
    Marketing,
    Sales,
    Reporting,
  ],
  StockTrafficReportsPage: [Service, SuperAdmin, CountryManager, Reporting],
  BestPerformingReportsPage: [
    User,
    Service,
    SuperAdmin,
    CountryManager,
    Reporting,
  ],
};
